import { format } from "date-fns";

export const AccountCategoriesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "categoryName", headerName: "Category Name", flex: 1 },
  //   { field: "parentAccount", headerName: "Parent Account", flex: 1 },
  //   { field: "oldParent", headerName: "Old Parent", flex: 1 },
];
export const getAccountSubCategoriesColumns = (categories = []) => [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "accountCategory",
    headerName: "Category Name",
    flex: 1,
    valueGetter: (params) => {
      if (params.row?.accountCategory && params.row?.accountCategory !== "-") {
        return params.row.accountCategory;
      }
      const cat = categories.find((c) => c.id === params.row?.accountCategoryId);
      return cat?.categoryName || "-";
    },
  },
  {
    field: "accountCategoryName",
    headerName: "Sub Category",
    flex: 1,
    valueGetter: (params) =>
      params.row?.accountCategoryName || params.row?.accountName || "-",
  },
];

export const AccountSubCategoriesColumns = getAccountSubCategoriesColumns([]);
export const AccountsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },

  { field: "accountName", headerName: "Account Name", flex: 1 },
  { field: "accountNumber", headerName: "Account Number", flex: 1 },
  { field: "accountType", headerName: "Account Type", flex: 1 },

  { field: "currency", headerName: "Currency", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
];
export const PaymentTypesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  {
    field: "paymentType",
    headerName: "Payment Type",
    flex: 1,
    valueGetter: (params) => {
      const value = params.row?.paymentType;

      if (value === null || value === undefined || value === "") {
        return "-";
      }

      return value;
    },
  },
];
export const BanksColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "bankName", headerName: "Bank Name", flex: 1 },
  { field: "bankSwiftCode", headerName: "Bank Swift Code", flex: 1.2 },
  { field: "finCode", headerName: "Financial Code", flex: 1.1 },
  {
    field: "mobile",
    headerName: "Mobile",
    flex: 1,
    valueGetter: (params) => params.row.mobile || "-",
  },
  { field: "email", headerName: "Email", flex: 1 },
];
export const DocumnetsApproversColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "documentTypeId", headerName: "DocumentType", flex: 1 },
  { field: "approverUserId", headerName: "User", flex: 1.2 },
  { field: "isFinalApprover", headerName: "FinalApprover", flex: 1.1 },
];
export const BankBranchesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  // { field: "bankId", headerName: "Bank ID", flex: 1 },
  { field: "bankName", headerName: "Bank Name", flex: 1 },
  { field: "branchCode", headerName: "Branch Code", flex: 1 },
  { field: "branchName", headerName: "Branch Name", flex: 1 },
  { field: "branchSwiftCode", headerName: "Branch Swift Code", flex: 1 },
  // {
  //   field: "createdDate",
  //   headerName: "Created Date",
  //   flex: 1,
  //   valueGetter: (params) => {
  //     if (!params.value) return "-";
  //     try {
  //       return format(new Date(params.value), "dd/MM/yyyy");
  //     } catch (error) {
  //       return "-";
  //     }
  //   },
  // },
  // {
  //   field: "useInPrintout",
  //   headerName: "Use in Printout",
  //   flex: 0.8,
  //   valueGetter: (params) => {
  //     const value = params.row?.useInPrintout;

  //     if (value === null || value === undefined) return "-";
  //     if (value === 1 || value === true) return "Yes";
  //     return "No";
  //   },
  // },
];
export const allBankBranchesViewColumns = [
  { field: "id", headerName: "ID", flex: 0.3 },
  { field: "bankName", headerName: "Bank Name", flex: 1 },
  { field: "branchCode", headerName: "Branch Code", flex: 1 },
  { field: "branchName", headerName: "Branch Name", flex: 1.2 },
  { field: "branchSwiftCode", headerName: "Branch Swift Code", flex: 1 },
  {
    field: "useInPrintout",
    headerName: "Use in Printout",
    flex: 0.8,
    valueGetter: (params) => {
      const value = params.row?.useInPrintout;

      if (value === null || value === undefined) return "-";
      if (value === 1 || value === true) return "Yes";
      return "No";
    },
  },
];


export const BankAccountsColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "accountName", headerName: "Account Name", flex: 1.5 },
  { field: "accountNumber", headerName: "Account Number", flex: 1 },
  { field: "accountDescription", headerName: "Description", flex: 1.5 },
];
export const FiscalYearsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "fiscalYearName", headerName: "Fiscal Year", flex: 1 },
  {
    field: "startDate",
    headerName: "Start Date",
    flex: 1,
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  {
    field: "endDate",
    headerName: "End Date",
    flex: 1,
    valueGetter: (params) => {
      if (!params.value) return "-";
      const date = new Date(params.value);
      // Format as YYYY-MM-DD
      return date.toISOString().split("T")[0];
    },
  },
  { field: "status", headerName: "Status", flex: 1 },
];
export const TaxAuthoritiesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "taxAuthorityName", headerName: "Tax Authority Name", flex: 1 },
  { field: "jurisdiction", headerName: "Jurisdiction", flex: 1 },
  // { field: "countryId", headerName: "Country ID", flex: 1 },
  { field: "country", headerName: "Country", flex: 1 },
];

export const TaxRatesColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "name", headerName: "Name", flex: 1 },
  {
    field: "rate",
    headerName: "Rate",
    flex: 1,
    valueGetter: (params) => {
      const value = params.row?.rate;

      if (value === null || value === undefined) {
        return "-";
      }

      return value;
    },
  },
  // { field: "taxAuthorityID", headerName: "Tax Authority ID", flex: 1 },
  // { field: "countryId", headerName: "Country ID", flex: 1 },
  {
    field: "country",
    headerName: "Country",
    flex: 1,
    valueGetter: (params) =>
      params.row?.country?.country || "—",
  },
];

export const CurrencyColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "currencyCode", headerName: "Currency Code", flex: 1 },
  { field: "currencyName", headerName: "Currency Name", flex: 1 },
  // { field: "taxAuthorityID", headerName: "Tax Authority ID", flex: 1 },
  // { field: "countryId", headerName: "Country ID", flex: 1 },
  { field: "exchangeRate", headerName: "Exchange Rate", flex: 1 },
];

export const DebtorsListColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "debtorName", headerName: "Debtor Name", flex: 1.5 },
  { field: "invoiceNumber", headerName: "Invoice Number", flex: 1 },
  { field: "invoiceDate", headerName: "Invoice Date", flex: 1 },
  { field: "dueDate", headerName: "Due Date", flex: 1 },
  { field: "amountBilled", headerName: "Amount Billed", flex: 1 },
  { field: "amountPaid", headerName: "Amount Paid", flex: 1 },
  { field: "balanceDue", headerName: "Balance Due", flex: 1 },
  { field: "status", headerName: "Status", flex: 1 },
  { field: "contactEmail", headerName: "Email", flex: 1.5 },
  { field: "contactPhone", headerName: "Phone", flex: 1 },
  { field: "remarks", headerName: "Remarks", flex: 2 },
];

export const SuppliersColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "supplierName", headerName: "Supplier Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "contactNumber", headerName: "Contact Number", flex: 0.8 },
  { field: "address", headerName: "Address", flex: 1.5 },
  { field: "registrationNumber", headerName: "Registration Number", flex: 0.8 },
  { field: "industrySector", headerName: "Industry Sector", flex: 0.8 },
  { field: "isActive", headerName: "Status", flex: 0.5 },
];
